import { useMutation, useQueryClient } from "@tanstack/react-query";
import { runTargetareRisc } from "@/api/endpoints/targetare";
import { queryKeys } from "@/lib/queryClient";

export function useRunTargetareRisc() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: runTargetareRisc,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.targetare.all });
    },
  });
}
